module.exports = __webpack_public_path__ + "static/media/servicecloud-apiled.8937aa40.png";